/*
Poornima  09/19/2022  2700912712  Fixed GAL- 122,127,128,130,161,163,170,171,173 bugs
Poornima  09/20/2022  2700912712  Fixed GAL-127,131,166,171 bugs
Poornima  09/21/2022  2700912712  Fixed page break issue
Ashraf    10/13/2022  2700912712  fixed filter and formula rule group, communication history bug fixes
Ashraf    10/13/2022  2700912712  changed validation length for window name in custom windows, filter rule payload fix
Suresh Peddavoora 10/26/2022 2700912712 Changed Text Field Variant from outlined to standard.
akhila 10/27/2022 2700912712  bre UX Changes
Sohel 10/29/2022 2700912712  passing Copy functionality props.
Ravi 10/28/2022 2701135832 - Fixed Delete Issue of Add Sql Rule
Sai Maheshwar 10/29/2022 2701135832 - added SQL expression validation
Sohel 10/29/2022 2700912712 Fixed Validation Issue.
Sohel 10/30/2022 2701135832 changed payload.
Sohel 10/30/2022 2701135832 changed hide map field list.
Sohel 11/01/2022 3031450488 prepoulate table data.
Ashraf 11/01/2022 2701135832 reset rules after field list change
Ashraf 11/01/2022 2701135832 disable map field list when editing filter
Lalitha 11/03/2022 2701135832 changed textField placeHolderName and label
Sohel 11/05/2022 2701135832 fixed Existing Filter codes Not auto populated Issue
Sohel 11/05/2022 2701135832 auto populated removed description
Ashraf 11/08/2022 2701135832 renamed sql expression to result expression.
Akhila 11/08/2022 2701135832 auto populated removed in field descrpition
Sohel 11/09/2022 2701135832 prepoulate Filter code.
Sohel 11/09/2022 2701135832 fixed redirect issue
Sai Maheshwar 11/10/2022 2701135832 removed unwanted validation for sql expression
Sohel 11/11/2022 2701135832 fixed page break issue.
akhila 11/14/2022 2701135832 fixed validation bug
Ashraf 11/14/2022 2700912712 fixed bre role issue
Dilip 11/22/2022 2700912712 validation message changed
Sohel 11/23/2022 2700912712 reset add rules
akhila 11/26/2022 2700912712 passed overrideType in payload
Sohel 12/01/2022 2700912712 modified Api
Sai Maheshwar 12/03/2022 2701135832 added AND/OR conditions
lalitha 12/03/2022 2701135832 Radio button color changed
Saikrishna 12/08/2022 2698948956 Removed name fields.
Ashraf 12/15/2022 2698948956 fixed role access issue
Sohel 12/16/2022 2698948956 map Fields changes
Raghu 12/17/2022 2698948956 Button spacings and alignment fixes
Sohel 12/19/2022 2698948956 fixed Test functionality Payload Issue
Sai Maheshwar 12/19/2022 2698948956 fixed filter Test Payload Issue
akhila 12/20/2022 2698948956 changed label for button
akhila 12/23/2022 2698948956 changed test popup title
manikanta 12/26/2022 2698948956 added validation to addSqlRuleValidation
Prakash 12/26/2022 2698948956 Fields and Buttons Responsiveness issues.
Sai Maheshwar 12/12/2022 2700912712 added rule builder validations
kavyareddy 12/29/2022 2698948956 Fixed validation issue
kavyareddy 12/29/2022 2698948956 Fixed two save api's issue
Ashraf 01/02/2023 2698948956 renamed usage header title
Dilip 01/06/2023 2698948956 fixed validation issue for code and description
Dilip 01/06/2023 2698948956 disabled test button for empty value
sai krishna 01/11/2023 2698948956 rename the tooltip title
Akhila 01/30/2023 2698948956 Bug Fixed delete id issue while overRide and Reset Issue
Akhila 01/23/2023 2698948956 Result Title dyanmically change the value
Ravi 02/20/2023 2698948956 disable Map Fields button based on code and Description
Ravi 02/21/2023 2698948956 Display field Data Above the Add Filter Rule Button
Raghu 02/22/2023 2698948956 added new class for input fields and buttons
Raghu 03/01/2023 2698948956 fixed alignments
sohel 03/06/2023 2698948956 Added validation message for existing value
sohel 03/08/2023 2698948956 Added dialog box for empty filter and validation
Sohel 03/08/2023 2698948956 Changed disabled condition
suresh peddavoora 04/06/2023 2698948956 field alignments fixes
Sohel 04/13/2023 2698964415 Added Type Field in Filter Criteria
Sohel 04/13/2023 2698964415 Added Field Type Issue
Sohel 04/19/2023 2698964415 Added Data Calculation Field
Prakash 19/04/2023 2698811066 fixed button spaceing issue rule group.
Akhila 05/02/2023 2698811066 added rhsField,rhsRepository in payload in sql rules
Akhila 05/08/2023 2698811066 Added rhsField,rhsRepository in Test fucntionality payload
Sohel 05/10/2023 2698811066 Fixed Type Payload Issue
Akhila 05/10/2023 2698811066 changes in payload of test functioanlity
Prakash 16/05/2023 2698811066 Fixed alignments issue in tab view
Sohel 05/25/2023 2698964415 hide Data Calculation Field
Prakash 24/05/2023 2698964415 Fixed input field issues alignment
Akhila 05/31/2023 2698964415 unsaved changes bug fixed
Ravi 05/31/2023 2698964415 changed delete popup message
Sohel 05/31/2023 2698964415 Fixed Add Filter Rules Disabled Issue
Akhila 06/05/2023 2698964415 validation bug fix on between and not between
Akhila 06/14/2023 2700708915 bug fix unsaved changes on save button
Ravi 06/20/2023 2700708915 Added Breadcrums in popup
Akhila 06/20/2023 2700708915 bug fix field type for Date type
Akhila 06/21/2023 2700708915 conditionally disable save and finish button on submission
Akhila 06/22/2023 2700708915 modified payload for date sql code
Akhila 06/26/2023 2700708915 sql code for date is not blank fix
Sohel 10/06/2023  2701012930 Added Table Name and Field Name Changes
Sohel 10/09/2023 2701012930 Fixed dbColumn Name Payload Issue
Sohel 10/10/2023 2701012930 Fixed dbColumn Name Sql output Issue
Sohel 10/10/2023 2701012930 Fixed dbColumn Name Sql output Issue
Sohel 10/13/2023 2698811066 Filter Criteria Changed SQL Output
Sohel 10/16/2023 2698811066 SQl Output value Changes
sohel 12/11/2023 2698811066  Added validation for FilterCode and Filter Description in AddFilter
*/
import {
  Button,
  TextField,
  FormHelperText,
  Tooltip,
  MenuItem,
  RadioGroup,
  FormControlLabel,
  Radio,
} from '@material-ui/core';
import React, { useState, useEffect, useContext, useRef } from 'react';
import { fetchGlobalFieldListData } from '../../../../../redux/reducers/GlobalField/AddFieldList';
import DialogBox from '../../../../../components/DialogBox';
import AddRuleForm from './AddRuleForm';
import * as Yup from 'yup';
import {
  postFilterRuleGroup,
  testFilterResetData,
  fetchFilterAllCodeAndDisplayName,
  postMapFields,
  fetchMapFields,
  ResetStatus as resetStatus,
  ResetAddRule as resetAddRule,
  ResetMessage as resetMessage,
  resetFilterRuleId,
} from '../../../../../redux/reducers/BRE/AddRuleGroup';
import { getBaseCategory, resetData } from '../../../../../redux/reducers/GlobalField/AddFieldList';
import { useDispatch, useSelector } from 'react-redux';
import { ErrorSnackbar, SuccessSnackbar } from '../../../../../components/CustomSnackBar';
import PageLoader from '../../../../../components/PageLoader';
import AppContext from '../../../../../components/contextProvider/AppContextProvider/AppContext';
import { ThemeContext } from '../../../../../themes/ThemeProvider';
import OverrideRule from '../../../../../components/OverrideRule';
import AddIcon from '@material-ui/icons/Add';
import SearchFields from '../../../GlobalFields/DataRepositories/SearchDataRepositories/index';
import AddRuleFormFormula from './AddRuleFormFormula';
import SqlRuleBuilder from '../../../../../components/SqlRuleBuilder/FilterRules';
import TestComponent from './TestComponent';
import { ArrowBack } from '@material-ui/icons';
// import {nameRegexAllow} from '../../../../../util/RegexPatterns';
// import {nameWithSpecialCharacter} from '../../../../../util/Content';
import AccountTreeIcon from '@material-ui/icons/AccountTree';
import AddFieldListTable from '../../../EventTactics/AddEventTactic/MapFieldListTable';
import { Form, Formik, FieldArray, Field } from 'formik';
import DeleteTableRecordPopup from '../../../../../util/DeleteTableRecordPopup';
import { getOptions, getValue } from '../../../../../components/SqlRuleBuilder/FilterRulesUtils';
import SearchLogicField from '../../../DataManager/DataManagerRecord/AddDataManagerRecord/SearchLogicField';
import BreadCrums from '../../../../../util/BreadCrum';
import {
  submissionEnd,
  submissionStart,
} from '../../../../../redux/reducers/CommonActions/commonActions';
const typeOptions = [
  { label: 'Field', value: 'file' },
  { label: 'Value', value: 'value' },
];
const RuleGroup1 = ({
  setValue,
  setTabValue,
  selectedBaseCategory,
  setSelectedBaseCategory,
  dataReset,
  rowSelected,
  setShowFilterData,
  StepperFilter,
  isCopy,
  fieldListCode,
  setRuleGroupCodeData,
  setGroupId,
  overrideType,
  handleDirty,
}) => {
  useEffect(() => {
    dispatch(resetData());
    dispatch(getBaseCategory());
  }, []);
  const { roleData } = useSelector(({ role }) => role);
  const roleDataBre = roleData ? roleData?.window?.['Filter Rules']?.FR : {};
  const { reusableInputStyles } = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [openFormula, setOpenFormula] = useState(false);
  const [openFieldList, setOpenFieldList] = useState(false);
  const [formData, setFormData] = useState([]);
  const [formDataFormula, setFormDataFormula] = useState([]);
  const fieldsDeleteIdsRef = useRef([]);
  const [deletedIds, setDeletedIds] = useState([]);
  const {
    addRuleData,
    userMetrix,
    isLoading,
    successMsg,
    errorMsg,
    addRuleGroupStatus,
    filterRuleId,
    // filterRuleGroupData,
    addRuleStatus,
    allFilterCodeAndDisplayName,
    mapFieldsData,
  } = useSelector(({ addRuleGroup }) => addRuleGroup);
  const { filterRuleGroupData } = useSelector(({ addFilterRuleGroup }) => addFilterRuleGroup);
  const [tableDataReset, setReset] = useState(false);
  const { systemerrorMsg, systemsuccessMsg } = useSelector(({ systemNotes }) => systemNotes);
  const [deletedRules, setDeletedRules] = useState([]);
  const [isEditMode, setIsEditMode] = useState(false);
  const [isEditModeFormula, setIsEditModeFormula] = useState(false);
  // const [rowData, setRowData] = useState({});
  const rowData = {};
  // const [rowDataFormula, setRowDataFormula] = useState({});
  const rowDataFormula = {};
  // const [oldRuleCode, setOldRuleCode] = useState('');
  const oldRuleCode = '';
  // const [oldRuleCodeFormula, setOldRuleCodeFormula] = useState('');
  const oldRuleCodeFormula = '';
  const [selectedFieldList, setSelectedFieldList] = useState(null);
  const [sqlSNo, setSqlSNo] = useState(1);
  const [formulaSNo, setFormulaSNo] = useState(1);
  const [dialogState, setDialogState] = useState(false);
  const [overRiding, setOverRiding] = useState({});
  const [openTestForm, setOpenTestForm] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [ruleGroupCode, setRuleGroupCode] = useState('');
  // const [testRows, setTestRows] = useState([]);
  const testRows = [];
  // const [testColumns, setTestColumns] = useState([]);
  const testColumns = [];
  const resultRef = useRef();
  const arrayHelperRef = useRef();
  // const [fieldCode, setFieldCode] = useState([]);
  const fieldCode = [];
  const { reportMasterId } = useContext(AppContext);
  const currentDeleteIndex = useRef(null);
  const [codePopover, setCodePopover] = useState(false);
  const [filterCodesData, setFilterCodesData] = useState();
  const [tempSelectedRows, setTempSelectedRows] = useState([]);
  const [isDelete, setIsDelete] = useState(false);
  const [logicFieldsOpen, setLogicFieldsOpen] = useState(false);
  const filterRuleRoleAccess = roleData?.window?.['Filter Rules']?.['FR'];
  const [mapData, setMapData] = useState('');
  const [validate, setValidate] = useState(false);
  const formRef = useRef();
  const { enabledSubmission } = useSelector(({ commonActions }) => commonActions);
  const initialVal = {
    code: '',
    displayName: '',
    description: '',
    sqlExpression: '',
    formulaExpression: '',
    sqlRules: [],
    fieldList: '',
    resultExpCondition: 'AND',
  };
  const [initialValues, setInitialValues] = useState(initialVal);
  const formattedFieldList =
    selectedRows?.length > 0 &&
    selectedRows?.map((field) => ({
      globalField: field?.repositoryName + '.' + field?.fieldName,
      fieldType: field.fieldType,
      repository: field?.repositoryName,
      fieldName: field?.fieldName,
    }));
  const hideValuesConditions = [
    'Is',
    'Is not',
    'Less than',
    'Greater than',
    'Less than equal',
    'Greater than equal',
  ];

  const getFilterCodesData = () => {
    if (allFilterCodeAndDisplayName && allFilterCodeAndDisplayName?.length > 0) {
      return allFilterCodeAndDisplayName?.filter((i) =>
        String(i?.ruleGroupCode?.toUpperCase())?.startsWith(filterCodesData?.toUpperCase()),
      );
    } else {
      return [];
    }
  };
  // const getCategoryValue = () => {
  //   if (StepperFilter && fieldListCode) {
  //     return getCategoryObject(fieldListData.baseCategory, baseCategoryData);
  //   } else {
  //     return filterRuleGroupData?.category
  //       ? getCategoryObject(filterRuleGroupData?.category, baseCategoryData)
  //       : "";
  //   }
  // };
  useEffect(() => {
    handleDirty(false, 'reset');
  }, []);
  useEffect(() => {
    setSelectedBaseCategory(filterRuleGroupData?.category);
    setSelectedFieldList(filterRuleGroupData?.fieldListCode);
    if (filterRuleGroupData?.fieldListCode) {
      dispatch(fetchGlobalFieldListData(filterRuleGroupData?.fieldListCode));
    }
  }, [filterRuleGroupData]);

  useEffect(() => {
    dispatch(fetchFilterAllCodeAndDisplayName());
  }, []);
  const handleLogicFieldsClose = () => {
    setLogicFieldsOpen(false);
  };
  useEffect(() => {
    if (StepperFilter && fieldListCode) {
      dispatch(fetchGlobalFieldListData(fieldListCode));
      setSelectedFieldList(fieldListCode);
    }
  }, [fieldListCode]);

  const checkCodeExist = (value) => {
    if (allFilterCodeAndDisplayName && allFilterCodeAndDisplayName?.length > 0 && value) {
      const ar = [];
      allFilterCodeAndDisplayName.filter((i) => {
        if (
          i?.ruleGroupCode?.toLowerCase()?.trim() === value?.toLowerCase()?.trim() &&
          i?.isActive === 'Y'
        ) {
          ar.push(i);
        }
      });
      return ar.length > 0;
    } else {
      return false;
    }
  };
  const checkCodeAlreadyExist = (value) => {
    if (allFilterCodeAndDisplayName && allFilterCodeAndDisplayName?.length > 0 && value) {
      const ar = [];
      allFilterCodeAndDisplayName.filter((i) => {
        if (
          i?.ruleGroupCode?.toLowerCase()?.trim() === value?.toLowerCase()?.trim() &&
          i?.isActive === 'N'
        ) {
          ar.push(i);
        }
      });
      return ar.length > 0;
    } else {
      return false;
    }
  };
  const validationSchema = Yup.object().shape({
    code: initialValues.code
      ? ''
      : Yup.string()
        .required('Filter Name is required')
        .test('fieldListCode', 'Filter Name already exist', (value) => !checkCodeExist(value))
        .test(
          'fieldListCode',
          'Filter Name has already been used in the past',
          (value) => !checkCodeAlreadyExist(value),
        ),
    // displayName: initialValues.displayName
    //   ? ""
    //   : Yup.string()
    //       .required("Filter Name is required")
    //       .test(
    //         "displayName",
    //         "Filter Name already exist",
    //         (value) => !checkDisplayNameExist(value)
    //       ),
    description: Yup.string().required('Filter Description is required'),
    sqlRules: Yup.array().of(
      Yup.object().shape({
        field: Yup.mixed().required('Field is required'),
        condition: Yup.mixed().required('Condition is required'),
        value: Yup.mixed().when('condition', {
          is: (val) => {
            return !['isNotBlank', 'isBlank'].includes(val?.value);
          },
          then: Yup.mixed().required('Value is required'),
        }),
        value1: Yup.mixed().when('condition', {
          is: (val) => {
            return ['BETWEEN', 'NOT BETWEEN'].includes(val?.value);
          },
          then: Yup.mixed().required('Value is required'),
        }),
        type: Yup.mixed().test('type', 'Type is required', (value, ctx) => {
          if (!value?.value && hideValuesConditions?.includes(ctx.parent?.condition?.label)) {
            return false;
          } else {
            return true;
          }
        }),
      }),
    ),
    //  sqlExpression: Yup.string()
    // .test("sql expression", "Invalid SQL Expression", (value, context) => {
    //   const rulesCount = rules.length;
    //   const regex = rulesCount ? new RegExp(`S*[1-${rulesCount}]`, "g") : null;
    //   if (rulesCount && regex && regex.test(value)) {
    //     return true;
    //   } else {
    //     return false;
    //   }
    // })
    // .required("Result Expression is required")

    sqlExpression: Yup.string().when('sqlRules', {
      is: (sqlRules) => sqlRules.length > 0,
      then: Yup.string().required('Result Expression is required'),
    }),
  });
  const handleClose = () => {
    setSqlSNo(formData?.length);
    setFormulaSNo(formDataFormula?.length);
    setOpen(false);
    setOpenFormula(false);
    setIsEditMode(false);
    setIsEditModeFormula(false);
  };

  // const {
  //   register,
  //   handleSubmit,
  //   reset,
  //   control,
  //   errors,
  //   getValues,
  //   watch,
  //   setValue: setValueRuleGroup,
  // } = ({
  //   mode: "onChange",
  //   defaultValues: initialValues,
  //   resolver: yupResolver(validationSchema),
  // });
  const handleResultExpression = (arr, setFieldValue, resultExpCondition) => {
    if (!resultRef.current) {
      const result = arr.map((el, i) => el.ruleCode);
      if (result.length > 0 && resultExpCondition) {
        setFieldValue('sqlExpression', result.join(` ${resultExpCondition} `));
      } else {
        setFieldValue('resultExpCondition', 'AND');
        setFieldValue('sqlExpression', '');
      }
    }
  };
  const { eventTacticData, triggerId } = useSelector(({ addEventTactic }) => addEventTactic);
  const getSelectedRowsLength = (selectedRows) => {
    return selectedRows?.length;
  };
  const handleDeleteRule = () => {
    const i = currentDeleteIndex.current;
    const {
      form: { values, setFieldValue },
    } = arrayHelperRef.current;
    const copyArr = [...values.sqlRules];

    const copyDeleteArr = [...deletedRules];
    if ('filterSQLRuleResponse' in filterRuleGroupData) {
      copyDeleteArr.push(filterRuleGroupData?.filterSQLRuleResponse[i]?.id);
    }
    copyArr.splice(i, 1);
    setDeletedRules(copyDeleteArr.filter(Boolean));
    if (arrayHelperRef.current) {
      arrayHelperRef.current.remove(currentDeleteIndex.current);
      handleResultExpression(copyArr, setFieldValue, values.resultExpCondition);
    }
    setIsDelete(false);
    handleDirty(true);
  };

  useEffect(() => {
    if (addRuleStatus === 200 && userMetrix === 'Yes') {
      setDialogState(true);
      setTimeout(() => {
        dispatch(resetAddRule());
      }, 1000);
    }
  }, [userMetrix, addRuleStatus]);
  useEffect(() => {
    if (mapFieldsData?.formulaFieldsRequest?.length > 0) {
      const fieldsTableData = mapFieldsData?.formulaFieldsRequest?.map((field) => {
        return {
          category: field?.category,
          // fieldListCode: field?.fieldListCode?.toUpperCase(),
          formulaFieldMapId: field?.formulaFieldMapId,
          fieldName: field?.fieldName,
          fieldType: field?.dataType,
          repositoryName: field?.repositoryName,
          dbColumnName: field?.dbColumnName,
          dataRepositoryId: field?.dataRepositoryId || 0,
          repositoryFieldId: field?.fieldId || 0,
          // repositoryType: field?.repositoryType,
        };
      });

      // Remove duplicate fields
      const uniqueArray = fieldsTableData.filter(
        (value, index, self) => index === self.findIndex((t) => t.repositoryName === value.repositoryName && t.fieldName === value.fieldName),
      );

      setSelectedRows(uniqueArray);
    }
  }, [mapFieldsData]);
  useEffect(() => {
    if (Object.keys(filterRuleGroupData).length > 0) {
      const newInitialVal = {
        code: dataReset || isCopy ? '' : filterRuleGroupData.code ? filterRuleGroupData?.code : '',
        displayName:
          dataReset || isCopy
            ? ''
            : filterRuleGroupData?.displayName
              ? filterRuleGroupData.displayName
              : '',
        description: dataReset || isCopy ? '' : filterRuleGroupData?.description || '',
        returnType: filterRuleGroupData?.returnType ? filterRuleGroupData?.returnType : '',
        sqlExpression: filterRuleGroupData?.sqlExpression ? filterRuleGroupData?.sqlExpression : '',
        formulaExpression: filterRuleGroupData?.formulaExpression
          ? filterRuleGroupData?.formulaExpression
          : '',
        // category: getCategoryValue(),
        fieldList: selectedFieldList
          ? selectedFieldList
          : filterRuleGroupData?.fieldListCode
            ? filterRuleGroupData.fieldListCode
            : '',
        resultExpCondition:
          filterRuleGroupData?.defaultOperator == null
            ? 'AND'
            : filterRuleGroupData?.defaultOperator,
      };
      const sqlRules =
        filterRuleGroupData.filterSQLRuleResponse &&
        filterRuleGroupData.filterSQLRuleResponse.map((data) => {
          const selectedFieldList =
            mapFieldsData.formulaFieldsRequest &&
            mapFieldsData.formulaFieldsRequest.filter(
              (el) => el.fieldName + el.repositoryName === data.field + data.repository,
            )[0];
          const selectedCondition =
            selectedFieldList &&
            getOptions(selectedFieldList?.dataType?.toLowerCase()).filter(
              (el) => el.value === data.filterCondition,
            )[0];
          let field;
          if (selectedFieldList) {
            const globalField =
              selectedFieldList?.repositoryName + '.' + selectedFieldList?.fieldName;
            const {
              dataType: fieldType,
              fieldName: fieldName,
              repositoryName: repository,
              // dbColumnName: globalField,
            } = selectedFieldList;
            field = { fieldType, globalField, fieldName, repository };
          }
          console.log(selectedFieldList, 'Selected Field List');
          const obj = {
            field: field ? field : null,
            condition: selectedCondition,
            value:
              data?.type === 'file'
                ? mapFieldsData?.formulaFieldsRequest
                  ?.filter((el) => data.value.includes(el.fieldName))
                  ?.map((el) => ({ ...el, fieldName: data.value }))[0]
                : data.value || '',
            sqlValue: data.sqlExpression,
            value1: data.value1,
            ruleCode: data.ruleCode,
            id: data.id,
            createdBy: data.createdBy,
            groupCode: data.groupCode,
            type: data.type ? typeOptions?.filter((el) => el.value === data?.type)?.[0] : '',
          };
          return obj;
        });
      sqlRules.sort((a, b) => {
        if (a.ruleCode < b.ruleCode) {
          return -1;
        }
        if (a.ruleCode > b.ruleCode) {
          return 1;
        }

        // names must be equal
        return 0;
      });
      setInitialValues((prev) => ({ ...prev, ...newInitialVal, sqlRules: sqlRules }));
    }
  }, [filterRuleGroupData, tableDataReset, mapFieldsData]);
  const handleFieldListClose = () => {
    setOpenFieldList(false);
  };
  const handleDialogState = () => {
    setDialogState(false);
  };
  useEffect(() => {
    if (addRuleGroupStatus === 200) {
      setTimeout(() => {
        dispatch(resetMessage());
        const obj = { ...mapData };
        obj.formulaFieldsRequest = obj.formulaFieldsRequest.map((item) => ({
          ...item,
          filterFormulaGroupId: filterRuleId,
        }));
        dispatch(resetFilterRuleId());
        dispatch(postMapFields(obj));
        if (StepperFilter) {
          setShowFilterData(false);
          setRuleGroupCodeData(
            !isCopy && filterRuleGroupData?.code ? filterRuleGroupData?.code : ruleGroupCode,
          );
          setGroupId(!isCopy && filterRuleGroupData?.groupId ? filterRuleGroupData?.groupId : '');
        } else {
          setValue(0);
        }
      }, 1000);
      dispatch(resetStatus());
      // !StepperFilter && setValue(0);
      setFormData([]);
      setFormDataFormula([]);
      if (reportMasterId !== '') {
        setTabValue(0);
      }
    }
  }, [addRuleGroupStatus]);
  const onSubmitHandler = (data) => {
    if (data.sqlRules.length === 0) {
      setValidate(true);
    } else if (data.sqlRules.length > 0) {
      dispatch(submissionStart());
      const mapFieldListData = {
        formulaFieldsRequest:
          selectedRows?.length > 0
            ? selectedRows?.map((item) => {
              return {
                category: item?.category,
                dataType: item?.fieldType,
                fieldName: item?.fieldName,
                dataRepositoryId: item?.dataRepositoryId || 0,
                fieldId: item?.repositoryFieldId || item?.fieldId || 0,
                formulaFieldMapId: item?.formulaFieldMapId ? item?.formulaFieldMapId : 0,
                groupCode:
                    dataReset || isCopy
                      ? data.code
                      : filterRuleGroupData?.code
                        ? filterRuleGroupData?.code?.toUpperCase()
                        : data?.code?.toUpperCase(),
                repositoryName: item?.repositoryName,
                ruleType: 'Filters',
                dbTableName: item?.dbTableName ? item?.dbTableName : '',
                dbColumnName: item?.dbColumnName ? item?.dbColumnName : '',
              };
            })
            : [],
        deleteDataCalculationsFilterIds: [...new Set(fieldsDeleteIdsRef?.current?.filter(Boolean))],
      };
      setMapData(mapFieldListData);
      const passValues = {
        sqlRules: data.sqlRules.map((item, i) => {
          return {
            groupCode:
              dataReset || isCopy
                ? data.code
                : filterRuleGroupData?.code
                  ? filterRuleGroupData?.code?.toUpperCase()
                  : data?.code?.toUpperCase(),
            id: dataReset || isCopy ? 0 : item?.id ? item?.id : 0,
            ruleCode: item?.ruleCode,
            field: item?.field?.fieldName,
            filterRuleGroupId: triggerId ? triggerId : filterRuleGroupData?.id,
            repository: item.field.repository,
            filterCondition: item?.condition?.value,
            sqlExpression: item?.sqlValue,
            value1: item?.value1,
            value: item?.type?.value === 'file' ? item?.value?.fieldName : item?.value,
            type:
              hideValuesConditions?.includes(item?.condition?.label) && item?.type?.value
                ? item?.type?.value
                : '',
            rhsField: item?.type?.value === 'file' ? item?.value?.fieldName : '',
            rhsRepository: item?.type?.value === 'file' ? item?.value?.repositoryName : '',
          };
        }),
        id: dataReset || isCopy ? 0 : filterRuleGroupData?.id ? filterRuleGroupData?.id : 0,
        sqlDeletedId: deletedRules?.length > 0 ? deletedRules : [],
        defaultOperator: data.resultExpCondition,
        override: filterRuleGroupData?.id ? 'No' : '',
        code: initialValues.code ? initialValues.code : data.code,
        description: data?.description ? data?.description : '',
        displayName: initialValues?.displayName ? initialValues?.displayName : data?.displayName,
        sqlExpression: data?.sqlExpression ? data?.sqlExpression : '',
        category: data?.category?.categoryCode ? data?.category?.categoryCode : '',
        // fieldListCode: selectedFieldList,
        isDraft: 'N',
        oldFilterRuleGroupCode: dataReset || isCopy ? filterRuleGroupData?.code : '',
        overrideType: overrideType ? 'TRIGGER' : '',
      };
      setOverRiding(passValues);
      dispatch(postFilterRuleGroup(passValues));
    }
  };

  const handleSubmit = () => {
    const data = formRef.current?.values;
    if (data) {
      const mapFieldListData = {
        formulaFieldsRequest:
          selectedRows?.length > 0
            ? selectedRows?.map((item) => {
              return {
                category: item?.category,
                dataType: item?.fieldType,
                fieldName: item?.fieldName,
                formulaFieldMapId: item?.formulaFieldMapId ? item?.formulaFieldMapId : 0,
                dataRepositoryId: item?.dataRepositoryId || 0,
                fieldId: item?.repositoryFieldId || item?.fieldId || 0,

                groupCode:
                    dataReset || isCopy
                      ? data.code
                      : filterRuleGroupData?.code
                        ? filterRuleGroupData?.code?.toUpperCase()
                        : data?.code?.toUpperCase(),
                repositoryName: item?.repositoryName,
                ruleType: 'Filters',
              };
            })
            : [],
        deleteDataCalculationsFilterIds: fieldsDeleteIdsRef.current?.filter(Boolean),
      };
      setMapData(mapFieldListData);
      const passValues = {
        sqlRules: data.sqlRules.map((item, i) => {
          return {
            groupCode:
              dataReset || isCopy
                ? data.code
                : filterRuleGroupData?.code
                  ? filterRuleGroupData?.code?.toUpperCase()
                  : data?.code?.toUpperCase(),
            id: dataReset || isCopy ? 0 : item?.id ? item?.id : 0,
            ruleCode: item?.ruleCode,
            field: item?.field?.fieldName,
            repository: item.field.repository,
            filterCondition: item?.condition?.value,
            sqlExpression: item?.sqlValue,
            value1: item?.value1,
            value: item?.type?.value === 'file' ? item?.value?.fieldName : item?.value,
            type:
              hideValuesConditions?.includes(item?.condition?.label) && item?.type?.value
                ? item?.type?.value
                : '',
            rhsField: item?.type?.value === 'file' ? item?.value?.fieldName : '',
            rhsRepository: item?.type?.value === 'file' ? item?.value?.repositoryName : '',
          };
        }),
        id: dataReset || isCopy ? 0 : filterRuleGroupData?.id ? filterRuleGroupData?.id : 0,
        sqlDeletedId: deletedRules?.length > 0 ? deletedRules : [],
        defaultOperator: data.resultExpCondition,
        override: filterRuleGroupData?.id ? 'No' : '',
        code: initialValues.code ? initialValues.code : data.code,
        description: data?.description ? data?.description : '',
        displayName: initialValues?.displayName ? initialValues?.displayName : data?.displayName,
        sqlExpression: data?.sqlExpression ? data?.sqlExpression : '',
        category: data?.category?.categoryCode ? data?.category?.categoryCode : '',
        // fieldListCode: selectedFieldList,
        isDraft: 'N',
        oldFilterRuleGroupCode: dataReset || isCopy ? filterRuleGroupData?.code : '',
        overrideType: overrideType ? 'TRIGGER' : '',
      };
      setOverRiding(passValues);
      dispatch(postFilterRuleGroup(passValues));
    }
    handleDirty(false, 'fixed');
  };

  const handleValidationClose = () => {
    setValidate(false);
    dispatch(submissionEnd());
  };

  const handleTestFormClose = () => {
    dispatch(testFilterResetData());
    setOpenTestForm(false);
  };
  const handleDeleteClose = () => {
    setIsDelete(false);
  };

  const handleTest = (values) => {
    const passValuesTest = {
      fieldListCode: filterRuleGroupData?.fieldListCode,
      result: values.sqlExpression,
      sqlRules: values.sqlRules?.map((item) => {
        return {
          groupCode: filterRuleGroupData?.code
            ? filterRuleGroupData?.code.toUpperCase()
            : ruleGroupCode.toUpperCase(),
          ruleCode: item.ruleCode,
          sqlCode:
            ['file', 'value']?.includes(item?.type?.value) ||
            ['date']?.includes(item?.field?.fieldType?.toLowerCase())
              ? item?.sqlValue
              : ['text', 'amount', 'email', 'ssn', 'phone', 'number', 'varchar']?.includes(
                item?.field?.fieldType?.toLowerCase(),
              )
                ? item?.sqlValue
                : getValue(item.sqlValue),
          id: item?.id || 0,
          field: item?.field?.fieldName,
          repository: item?.field?.repository,
          filterCondition: item?.condition?.value,
          rhsField: item?.type?.value === 'file' ? item?.value?.fieldName : '',
          rhsRepository: item?.type?.value === 'file' ? item?.value?.repositoryName : '',
        };
      }),
    };
    return passValuesTest;
  };
  window.onclick = function () {
    setCodePopover(false);
  };
  useEffect(() => {
    if (filterRuleGroupData?.code) {
      const data = {
        groupCode: filterRuleGroupData?.code,
        ruleType: 'Filters',
        filterFormulaRuleGroupId: filterRuleGroupData?.id || 0,
      };
      dispatch(fetchMapFields(data));
    }
  }, [filterRuleGroupData]);
  return (
    <>
      <DialogBox
        open={logicFieldsOpen}
        dialogClose={handleLogicFieldsClose}
        title="Search Data Calculations Fields"
        maxWidth="xl"
      >
        <SearchLogicField
          setAuditFieldValue={setSelectedRows}
          dmValues={selectedRows}
          setTempSelectedRows={setTempSelectedRows}
          tempSelectedRows={tempSelectedRows}
          handleClose={handleLogicFieldsClose}
          dmRecordCategory={{ categoryCode: 'CO', categoryName: 'Core' }}
          deletedProcessorFields={fieldsDeleteIdsRef}
          isRecordFormat={false}
          isTriggerMaintenance={true}
        />
      </DialogBox>
      <DeleteTableRecordPopup
        open={validate}
        dialogClose={handleValidationClose}
        title="Warning !"
        value={`Filter Rule hasn't been added, Would you like to Skip and Continue?`}
        handleSubmit={handleSubmit}
      />
      <DialogBox
        open={openFieldList}
        dialogClose={handleFieldListClose}
        // title="Search Repository Fields"
        title={
          <div className="dialog-breadcrum">
            <p className="dialoge-title-breadcrum">
              <b>Search Repository Fields</b>
            </p>
            <BreadCrums
              name={'Trigger Name'}
              code={eventTacticData?.code}
              description={'Trigger Description'}
              descriptionValue={eventTacticData?.description}
            />
          </div>
        }
        maxWidth="xl"
      >
        <SearchFields
          isTriggers={true}
          isReports={true}
          setSelectedRows={setSelectedRows}
          selectedRows={selectedRows}
          mapFields={true}
          moduleName={'TRIGGER'}
          tempSelectedRows={tempSelectedRows}
          handleClose={handleFieldListClose}
          setTempSelectedRows={setTempSelectedRows}
          fieldsDeleteIdsRef={fieldsDeleteIdsRef}
        />
      </DialogBox>
      <Formik
        validationSchema={validationSchema}
        initialValues={initialValues}
        onSubmit={onSubmitHandler}
        enableReinitialize
        innerRef={formRef}
      >
        {(props) => {
          const {
            values,
            setFieldValue: setValueRuleGroup,
            handleBlur,
            touched,
            resetForm,
            handleChange,
            errors,
            dirty,
          } = props;
          if (dirty) {
            handleDirty(dirty);
          }
          return (
            <Form noValidate>
              <div>
                {!StepperFilter && (
                  <div className="button-table-spacing-mb justify-content-start">
                    <Button
                      variant="outlined"
                      type="button"
                      disabled={isLoading || successMsg}
                      className={`search-btn mx-1 ${classes.buttonRoot}`}
                      onClick={(event) => {
                        setValue(0);
                      }}
                    >
                      <ArrowBack className="mr-2" />
                      Search Filter Rule
                    </Button>
                  </div>
                )}
                <div className="form-row new-standard-textfields">
                  <div className="col-sm-6 col-md-4 col-lg-3 col-xl-3 form-group">
                    <TextField
                      value={values.code}
                      className={` ${classes.labelName}`}
                      placeholder="Enter Filter Name"
                      margin="dense"
                      name="code"
                      variant="outlined"
                      label="Filter Name"
                      onBlur={handleBlur}
                      inputProps={{ maxLength: 25 }}
                      disabled={
                        Object.keys(filterRuleGroupData).length > 0 && !dataReset && !isCopy
                      }
                      // InputLabelProps={{
                      //   shrink: true,
                      // }}
                      onChange={(e) => {
                        setValueRuleGroup('code', e.target.value);
                        setRuleGroupCode(e.target.value);
                        if (e.target.value) {
                          setCodePopover(true);
                          setFilterCodesData(e.target.value);
                        } else if (e.target.value === '') {
                          setCodePopover(false);
                        }
                      }}
                      required
                      fullWidth
                      error={Boolean(touched.code && errors.code)}
                    />
                    <FormHelperText variant="outlined">
                      {touched?.code && errors?.code ? errors.code : ''}
                    </FormHelperText>
                    <div className="windowcode-popover Add-trigger-group-popover">
                      {codePopover &&
                        getFilterCodesData()?.map((data) => (
                          <MenuItem key={data?.ruleGroupCode}>{data?.ruleGroupCode}</MenuItem>
                        ))}
                    </div>
                  </div>
                  <div className="col-sm-6 col-md-4 col-lg-4 col-xl-3 form-group">
                    <TextField
                      value={values.description}
                      className={` ${classes.labelName}`}
                      placeholder="Enter Filter Description"
                      margin="dense"
                      name="description"
                      variant="outlined"
                      label="Filter Description"
                      onChange={handleChange}
                      required
                      inputProps={{ maxLength: 100 }}
                      onBlur={handleBlur}
                      // InputLabelProps={{
                      //   shrink: true,
                      // }}
                      fullWidth
                      error={Boolean(touched.description && errors.description)}
                    />
                    <FormHelperText variant="outlined">
                      {touched?.description && errors?.description ? errors.description : ''}
                    </FormHelperText>
                  </div>
                </div>
                <div className="new-standard-textfields table-header map-fields-btns table-card-header justify-content-end">
                  {/* <Button
                    variant="outlined"
                    className={`search-btn mx-1 ${classes.buttonRoot} mb-2 `}
                    onClick={() => setLogicFieldsOpen(true)}
                    disabled={values?.code === "" || values?.description === ""}
                    startIcon={<AddIcon />}
                  >
                    Data Calculations Fields
                  </Button> */}
                  <Button
                    variant="outlined"
                    className={`search-btn ${classes.buttonRoot} mb-2`}
                    onClick={() => setOpenFieldList(true)}
                    // disabled={!values?.category}
                    disabled={values?.code === '' || values?.description === ''}
                    startIcon={<AccountTreeIcon />}
                  >
                    Map Fields
                  </Button>
                  <AddFieldListTable
                    selectedRows={selectedRows}
                    setSelectedRows={setSelectedRows}
                    deletedIds={deletedIds}
                    setDeletedIds={setDeletedIds}
                    fieldsDeleteIdsRef={fieldsDeleteIdsRef}
                    handleDirty={handleDirty}
                  />
                </div>
              </div>
              <FieldArray
                name="sqlRules"
                render={(arrayHelpers) => {
                  return (
                    <>
                      {values.sqlRules.map((rule, index) => (
                        <>
                          <Field
                            key={index}
                            name={`sqlRules[${index}]`}
                            component={SqlRuleBuilder}
                            index={index}
                            fields={formattedFieldList}
                            handleDelete={() => {
                              setIsDelete(true);
                              currentDeleteIndex.current = index;
                              arrayHelperRef.current = arrayHelpers;
                            }}
                            mapFieldsData={selectedRows}
                            isFilterRules={true}
                          />
                          {/* <ErrorMessage name="rules" /> */}
                        </>
                      ))}
                      <div className="table-header mt-3 new-standard-textfields">
                        {/* <Typography variant="h4"></Typography> */}
                        <RadioGroup
                          aria-label="resultExpCondition"
                          name="resultExpCondition"
                          value={values.resultExpCondition}
                          onChange={(e) => {
                            handleChange(e);
                            const result = values.sqlRules.map((el, i) => el.ruleCode);
                            resultRef.current = false;
                            setValueRuleGroup('sqlExpression', result.join(` ${e.target.value} `));
                          }}
                          style={{
                            display: 'flex',
                            justifyContent: 'start',
                            flexDirection: 'row',
                          }}
                        >
                          <FormControlLabel
                            value="AND"
                            control={
                              <Radio color="primary" disabled={values.resultExpCondition == ''} />
                            }
                            label="AND"
                          />
                          <FormControlLabel
                            value="OR"
                            control={<Radio color="primary" />}
                            label="OR"
                            disabled={values.resultExpCondition == ''}
                          />
                        </RadioGroup>
                        {getSelectedRowsLength(selectedRows) > 0 ? (
                          <Button
                            variant="outlined"
                            className={`search-btn mx-1 ${classes.buttonRoot}`}
                            disabled={!filterRuleRoleAccess?.add}
                            onClick={() => {
                              // handleAddRule();
                              handleDirty(true);
                              const newRuleCount =
                                values.sqlRules.length > 0 &&
                                Number(
                                  values.sqlRules[values.sqlRules.length - 1].ruleCode.slice(1),
                                ) + 1;
                              const newRuleCode =
                                values.sqlRules.length > 0 ? 'S' + newRuleCount : 'S1';
                              arrayHelpers.push({
                                ruleCode: newRuleCode,
                                field: '',
                                condition: '',
                                value: '',
                                value1: '',
                                sqlValue: '',
                              });
                              if (!resultRef.current && values['resultExpCondition']) {
                                const result = values.sqlRules.map((el, i) => el.ruleCode);
                                result.push(newRuleCode);
                                setValueRuleGroup(
                                  'sqlExpression',
                                  result.join(` ${values['resultExpCondition']} `),
                                );
                              }
                            }}
                          >
                            <AddIcon />
                            Add Filter Rule
                          </Button>
                        ) : (
                          <Tooltip title="Please map field list to add a rule">
                            <span>
                              <Button
                                variant="outlined"
                                disabled
                                className={`search-btn mx-1 ${classes.buttonRoot}`}
                              >
                                <AddIcon />
                                Add Filter Rules
                              </Button>
                            </span>
                          </Tooltip>
                        )}
                      </div>
                    </>
                  );
                }}
              />
              {/* <RuleBuilder
            rules={rules}
            setRules={setRules}
            deletedRules={deletedRules}
            setDeletedRules={setDeletedRules}
            fields={formattedFieldList}
          /> */}
              <div className="d-flex justify-content-space-between align-items-center mt-4 new-standard-textfields">
                <div className="col-md-6 col-lg-4 col-xl-4 pl-0 form-group">
                  <TextField
                    className={` ${classes.labelName}`}
                    placeholder="Result Expression"
                    margin="dense"
                    name="sqlExpression"
                    required={values?.sqlRules?.length > 0}
                    disabled={values?.sqlRules?.length === 0}
                    value={values.sqlExpression}
                    variant="outlined"
                    label="Result Expression"
                    onBlur={handleBlur}
                    onChange={(e) => {
                      handleChange(e);
                      if (e.target.value.length > 0) {
                        resultRef.current = true;
                        setValueRuleGroup('resultExpCondition', '');
                      }
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    fullWidth
                    error={Boolean(touched.sqlExpression && errors.sqlExpression)}
                  />
                  <FormHelperText variant="outlined">
                    {touched?.sqlExpression && errors?.sqlExpression ? errors.sqlExpression : ''}
                  </FormHelperText>
                </div>
                <Button
                  variant="outlined"
                  // disabled={!values?.sqlExpression}
                  className={`ml-auto search-btn ${classes.buttonRoot} mb-4`}
                  onClick={() => {
                    setTimeout(() => {
                      testColumns && testRows && setOpenTestForm(true);
                    }, 500);
                  }}
                >
                  Test
                </Button>
              </div>

              <div className="d-flex justify-content-center new-standard-textfields ">
                <Button
                  type="button"
                  onClick={() => {
                    // reset(initialValues);
                    setDeletedRules([]);
                    resetForm(initialValues);
                    setMapData({});
                    if (!Object.keys(filterRuleGroupData)?.length) {
                      setFormDataFormula([]);
                      setFormData([]);
                    } else {
                      setReset(!tableDataReset);
                    }
                  }}
                  variant="outlined"
                  className={`mx-1 reset-btn ${classes.buttonRoot}`}
                >
                  Reset
                </Button>
                {(Object.keys(filterRuleGroupData)?.length > 0
                  ? roleDataBre?.edit
                  : roleDataBre?.add) && values.sqlRules.length > 0 ? (
                    <Button
                      type="submit"
                      variant="outlined"
                      disabled={enabledSubmission}
                      className={`mx-1 search-btn ${classes.buttonRoot}`}
                    >
                    Save
                    </Button>
                  ) : (
                    <span>
                      <Button
                        type="submit"
                        variant="outlined"
                        className={`mx-1 search-btn ${classes.buttonRoot}`}
                        // disabled={!selectedRows.length > 0}
                        disabled={enabledSubmission}
                      >
                      Save
                      </Button>
                    </span>
                  )}
              </div>
              <DialogBox
                open={open || isEditMode}
                dialogClose={handleClose}
                hideFooter={true}
                title={(isEditMode && 'Edit Rule ') || (open && 'Add Rule')}
                maxWidth={'md'}
              >
                <AddRuleForm
                  rowData={rowData}
                  setFormData={setFormData}
                  formData={formData}
                  setOpen={setOpen}
                  handleClose={handleClose}
                  isEditMode={isEditMode}
                  oldRuleCode={oldRuleCode}
                  setIsEditMode={setIsEditMode}
                  fieldCode={fieldCode}
                  sqlSNo={sqlSNo}
                />
              </DialogBox>
              <DialogBox
                open={openFormula || isEditModeFormula}
                dialogClose={handleClose}
                hideFooter={true}
                title={(isEditModeFormula && 'Edit Rule ') || (openFormula && 'Add Rule')}
                maxWidth={'md'}
              >
                <AddRuleFormFormula
                  rowData={rowDataFormula}
                  setFormData={setFormDataFormula}
                  formData={formDataFormula}
                  setOpen={setOpenFormula}
                  handleClose={handleClose}
                  isEditMode={isEditModeFormula}
                  oldRuleCode={oldRuleCodeFormula}
                  setIsEditMode={setIsEditModeFormula}
                  fieldCode={fieldCode}
                  formulaSNo={formulaSNo}
                />
              </DialogBox>

              <OverrideRule
                dialogTitle="Override Rule"
                dialogOpen={dialogState}
                dialogClose={handleDialogState}
                title={`This Rule Group has been used in the following places.`}
                handleOverrideClose={handleDialogState}
                handleOverrideSubmit={() => {
                  dispatch(postFilterRuleGroup({ ...overRiding, override: 'Yes' }));
                  handleDialogState();
                }}
                data={addRuleData}
              />

              <DialogBox
                open={openTestForm}
                dialogClose={handleTestFormClose}
                title={
                  <>
                    <span>
                      <b>{'Run Test For'} :</b>
                    </span>
                    <span className="result-expression">{values?.sqlExpression}</span>
                  </>
                }
                maxWidth="lg"
              >
                <TestComponent passValuesTest={handleTest(values)} />
              </DialogBox>
              <DeleteTableRecordPopup
                open={isDelete}
                dialogClose={handleDeleteClose}
                title="Delete Filter Rule"
                value={`Are you sure you want to delete the ${
                  values?.sqlRules[currentDeleteIndex.current]?.ruleCode
                }  Filter Rule?`}
                handleSubmit={handleDeleteRule}
              />
            </Form>
          );
        }}
      </Formik>
      {isLoading && <PageLoader />}
      {(errorMsg || systemerrorMsg) && <ErrorSnackbar errorMsg={errorMsg || systemerrorMsg} />}
      {(successMsg || systemsuccessMsg) && (
        <SuccessSnackbar successMsg={successMsg || systemsuccessMsg} />
      )}
    </>
  );
};

export default RuleGroup1;
